//import logger from '../../services/logger';

const Recycle = () => {
};

export default Recycle;